module.exports = __webpack_public_path__ + "img/icomoon.c6bc4ab9.svg";